// extracted by mini-css-extract-plugin
export default {"SideBarNavItem":"xmO_do8K"};